import { Orcamento } from "../../types/Orcamento";
import { getOrcamentos } from "../../data/Orcamento";
import { useState, useEffect } from 'react';
import styled from 'styled-components';

const Card = styled.div`
    padding: 1.75rem;
    border-radius: 2rem;
    border: 0px;
    background: #e0e0e0;
    box-shadow:  9px 9px 22px #bebebe,
             -9px -9px 22px #ffffff;
`

const Grid = styled.div`
    width: 100%;
    display: grid;
    padding-top: 1rem;
    grid-template: auto / auto;
    gap: 20px;
    @media (min-width: 768px){
        grid-template: auto / auto auto;
    }

    @media (min-width: 992px){
        grid-template: auto / auto auto auto ;
    }
    @media (min-width: 1200px){
        grid-template: auto / auto auto auto auto;
    }

    .name {
        flex: 1;
        font-weight: 600;
        font-size: 1.2rem;
    }

    .expand {
        font-weight: 600;
        font-size: 1.2rem;
    }

    .descricao {
        span {
            margin-left: 0.25rem;
        }

        p {
            margin-left: 0.75rem;
        }

        img {
            border-radius: 50%;
            width: 5rem;
            height: 5rem;
            margin-left: 0.25rem;
            margin-right: 0.25rem;
        }
    }

    .data {
        display: flex;
        justify-content: flex-start;
        alignt-items: center;
        flex: 1;
        font-size: 0.75rem;
        color: #777;
    }

    .status {
        font-size: 0.75rem;
    }
`

const AdminHome = () => {
    const [orcamentos, setOrc] = useState<Orcamento[]>();
    const [open, setOpen] = useState(0);

    useEffect(() => {
        const getAll = async () => {
            setOrc(await getOrcamentos());   
        }
        try {
            getAll();
        } catch (e) {
            console.log(e);
        }
    }, []);
    
    const toogle = (key: number) => {
		if(key+1 === open){
            setOpen(0);
        } else {
            setOpen(key+1)
        }
	}

    const filterDatePre = (inp: string) => {
        let x = inp.split('-');
        return x[2]+'/'+x[1];
    }

    const openRef = (ref: string) => {
        window.open(ref, '_blank');
    }

    const sendMessage = (whatsapp: string) => {
        let x = whatsapp.replace('(','').replace(')', '').replace('-', '');
        window.open('https://wa.me/55'+x,'_blank');
    }

    return(
        <>
            <div className="title">
                Orçamentos
            </div>
            <hr/>
            <Grid>
                {orcamentos?.map((orcamento, key) => (
                    <Card key={key}>
                        <div className="d-flex">
                            <div className="name">
                                {orcamento.name}
                            </div>
                            <div className="expand" onClick={() => toogle(key)}>
                                <i className={`bi bi-${open===key+1? 'dash' : 'plus'}`}/>
                            </div>
                        </div>
                        { open === key+1 &&
                            <div className="descricao">
                                <span>Descrição:</span>
                                <p>{orcamento.description}</p>
                                <span>Parte do corpo:</span>
                                <p>{orcamento.bodyPart} {orcamento.memberSide}</p>
                                <span>Tamanho:</span>
                                <p>{orcamento.estimatedSize} {orcamento.unMedida}</p>
                                <span>Data pretendida:</span>
                                <p>{filterDatePre(orcamento.datePre)} - {orcamento.hourPre}</p>
                                <span>Contato:</span>
                                <p>{orcamento.celphone}<br/>@{orcamento.instagram}<br/>{orcamento.email}</p>
                                <span>Referências</span>
                                <div>
                                    {orcamento.refs?.map((ref, key) => (
                                        key > 0 ? <img src={ref} onClick={() => openRef(ref)}/> : ''
                                    ))}
                                </div>
                            </div>
                        }
                        <hr/>
                        <div className="d-flex">
                            <div className="data">
                                {orcamento.sendDate}
                            </div>
                            <div className="status">
                                {orcamento.status? (
                                    <div>
                                        Respondido <i className="bi bi-check-square"></i>
                                    </div>
                                ) : (
                                    <div onClick={() => sendMessage(orcamento.celphone)}>
                                        Responder <i className="bi bi-reply-fill"></i>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>
                ))}
            </Grid>
        </>
    )
}

export default AdminHome;